"use client";

import React from "react";
import { ShieldCheck, Crosshair, Leaf, HardHat } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheEngineeringMindset() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const keywords = [{
    word: "Conviction",
    icon: HardHat
  }, {
    word: "Independence",
    icon: Leaf
  }, {
    word: "Asymmetry",
    icon: Crosshair
  }];
  return <section data-section-id="224942" id="the-yedey-philosophy" className="relative bg-background overflow-hidden border-y border-border">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-50 dark:opacity-20">
        <div className="absolute inset-0" style={{
        backgroundImage: `linear-gradient(to right, hsl(var(--primary) / 0.03) 1px, transparent 1px), linear-gradient(to bottom, hsl(var(--primary) / 0.03) 1px, transparent 1px)`,
        backgroundSize: "32px 32px"
      }} />
      </div>

      <div className="container mx-auto relative z-10 px-0 sm:px-4">
        <div className="flex flex-col lg:flex-row min-h-[700px] border-x border-border bg-background/80 backdrop-blur-sm">
          
          {}
          <div className="w-full lg:w-[60%] flex flex-col md:flex-row border-b lg:border-b-0 lg:border-r border-border">
            
            {}
            <div className="hidden md:flex w-16 border-r border-border flex-col items-center justify-between py-12 bg-muted/10">
              <div className="w-px h-24 bg-border" />
              <div className="flex flex-col gap-24 my-8">
                {keywords.map((kw, i) => {
                const Icon = kw.icon;
                return <div key={i} data-index={i} className="flex flex-col items-center gap-4">
                      <Icon className="w-4 h-4 text-primary/60" />
                      <span className="-rotate-90 whitespace-nowrap font-mono text-[10px] tracking-widest text-muted-foreground uppercase">
                        {kw.word}
                      </span>
                    </div>;
              })}
              </div>
              <div className="w-px h-24 bg-border" />
            </div>

            {}
            <div className="flex md:hidden border-b border-border p-4 justify-between bg-muted/10 overflow-x-auto">
              {keywords.map((kw, i) => {
              const Icon = kw.icon;
              return <div key={i} data-index={i} className="flex items-center gap-2 px-4">
                    <Icon className="w-3 h-3 text-primary" />
                    <span className="font-mono text-xs tracking-wider text-muted-foreground uppercase">
                      {kw.word}
                    </span>
                  </div>;
            })}
            </div>

            {}
            <div ref={textRef} className={`flex-1 p-8 md:p-12 lg:p-20 flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <Badge variant="outline" className="w-fit mb-8 font-mono rounded-md border-primary/40 text-primary bg-primary/10 uppercase tracking-widest px-3 py-1">
                Philosophy
              </Badge>
              
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold mb-8 tracking-tight text-foreground">
                The Pursuit of <br />
                <span className="text-primary">Sovereign Alpha</span>
              </h2>
              
              <div className="prose prose-slate dark:prose-invert max-w-none text-justify text-muted-foreground leading-[1.8] font-default">
                <p className="mb-6 text-lg">
                  At Yedey Investments, we believe that true alpha is found in the silence between the noise. In a world of algorithmic consensus and retail panic, independence is the ultimate competitive advantage. We don't follow the herd; we identify high-conviction asymmetric bets before they become mainstream narratives.
                </p>
                <p>
                  Our methodology is rooted in rigorous fundamental analysis and a deep understanding of market psychology. By focusing on concentrated positions in crypto and equities, we aim to capture outsized returns that traditional diversified portfolios simply cannot reach. We prioritize clarity over complexity and conviction over comfort.
                </p>
              </div>
            </div>
          </div>

          {}
          

        </div>
      </div>
    </section>;
}